import React from 'react'
import EnhancedAxios from '../../../axios/EnhancedAxios';
import { useSelector } from 'react-redux';
import { askForConfirmationAlert, errorAlert, successAlert } from '../../../utils/alerts/alerts';
import { Button } from '@mui/material';

type Props = {
    id: string;
}

const DeleteGift = ({ id }: Props) => {
    const userToken = useSelector((state: any) => state.user.userToken);

    const deleteProcess = () => {
        EnhancedAxios(null, userToken)
            .delete(`/admin/gifts/${id}`)
            .then((res: any) => {
                successAlert(`تم حذف الهدية`);
                window.location.reload();
            })
            .catch((error: any) => {
                errorAlert(error);
            });
    };
    const confirmDelete = () => {
        askForConfirmationAlert(
            "هل انت متاكد انك تريد حذف  الهدية",
            deleteProcess
        );
    };
    return (
        <Button onClick={confirmDelete}>حذف</Button>
    )
}

export default DeleteGift